import React, { useState, useRef, useEffect } from 'react';
import ArrayDropDownComponent from "@pages/components/ArrayDropDownComponent";
import {CustomTextContainer} from "@pages/new-design-components/custom-components";

// Ensure your CustomArea forwards the ref to the actual <textarea>
const CustomArea = React.forwardRef(({ value, onChange, ...rest }, ref) => {
    return <textarea ref={ref} value={value} onChange={onChange} {...rest} />;
});

const TextareaWithShortCodes = ({ initialValue = '', onChange,shortCodes,limit = false, maxLength = null}) => {
    const [text, setText] = useState(initialValue);
    const textareaRef = useRef();
    const parentObjectNames = ['customer', 'deal', 'dealer', 'vehicle'];
    const [selectedShortCodeMenu,setSelectedShortCodeMenu] = useState(null)
    useEffect(() => {
        setText(initialValue);
    }, [initialValue]);

    const insertAtCursor = (insertText) => {
        const textarea = textareaRef.current;
        const { selectionStart, selectionEnd } = textarea;

        const updatedText =
            text.slice(0, selectionStart) +
            insertText +
            text.slice(selectionEnd);

        setText(updatedText);
        onChange(updatedText);
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(
                selectionStart + insertText.length,
                selectionStart + insertText.length
            );
        }, 0);
    };

    const handleChange = (e) => {
        setText(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div>
            <div style={{ marginBottom: 10 }}>
                <ArrayDropDownComponent
                    items={parentObjectNames}
                    defaultText={'Menu'}
                    onSelect={(e) => setSelectedShortCodeMenu(e)}
                />
                {
                    selectedShortCodeMenu &&
                    <ArrayDropDownComponent
                        items={shortCodes[selectedShortCodeMenu]}
                        defaultText={selectedShortCodeMenu}
                        onSelect={(e) => insertAtCursor(e)}
                    />
                }

            </div>
            <CustomArea
                ref={textareaRef}
                maxLength={limit && maxLength}
                value={text}
                onChange={handleChange}
                style={{ width: '100%', minHeight: '150px', borderRadius: '8px', border: '1px solid #979797', padding: '10px' }}
            />
            {
                limit &&
                <CustomTextContainer marginTop={'6px'}
                                     marginBottom={'6px'}
                                     fontSize={'15px'}
                                     weight={'500'}
                                     color={'#74787E'}>{text.length} {'<='}{maxLength}</CustomTextContainer>
            }
        </div>
    );
};

export default TextareaWithShortCodes;
